import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PostChatRoomV2, PostChatV2Params, PostChatV2Model} from 'domain/usecases';
import {APIError} from 'data/errors/api-error';

export class RemotePostChatRoomV2 implements PostChatRoomV2 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostChatV2Model>,
	) {}

	async post(params: PostChatV2Params): Promise<PostChatV2Model> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
